import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_installer/install',
)({
  component: InstallPage,
})

function InstallPage() {
  const { organizationId } = Route.useParams()

  return (
    <Navigate
      to="/organization/$organizationId/install-flow"
      params={{ organizationId }}
      search={{ step: 'intro' }}
      replace
    />
  )
}
